module.exports = __webpack_public_path__ + "static/media/pattern-7.2e10d189.png";